// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function() {
  if (typeof window.CustomEvent === 'function') return false

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

// import external dependencies
import 'jquery';
import 'slick-carousel';

// Import everything from autoload
import './autoload/_foundation.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';
import awardsSectionsNav from './routes/awardsSectionsNav';
import single from './routes/single';
import postTypeArchivePbPodcasts from './routes/postTypeArchivePbPodcasts';
import postTypeArchivePbNewsPress from './routes/postTypeArchivePbNewsPress';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  blog,
  single,
  postTypeArchivePbPodcasts,
  postTypeArchivePbNewsPress,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
